// extracted by mini-css-extract-plugin
export default {"root":"Pagination_root__yK-zL","actual-page":"Pagination_actual-page__c0PV5","buttons-wrapper":"Pagination_buttons-wrapper__x6axL","page":"Pagination_page__43eyX"};